(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalTarifdetailsController', ModalTarifdetailsController);

    ModalTarifdetailsController.$inject = [
        '$modalInstance',
        'lodash',
        'tarifdetails'
    ];

    function ModalTarifdetailsController($modalInstance, _, tarifdetails) {
        var vm = this;

        activate();

        vm.onClose = onClose;

        function activate() {
            vm.tarifdetails = tarifdetails;

        }

        function onClose() {
            $modalInstance.close();
        }
    }

})();
